export default [
  {
    path: '/login',
    name: 'Auth',
    component: () => import(/* webpackChunkName: "Auth" */ '../auth/Auth')
  }
]



// WEBPACK FOOTER //
// ./src/pages/auth/router.js